export enum MemoryDragDropArea {
  MemoryInbox = 'MemoryInbox',
  AISuggestion = 'AISuggestion',
  PendingDraft = 'PendingDraft',
  LoggedHour = 'LoggedHour',
  HourDraft = 'HourDraft',
}

export type DropActionAreaSpecifier =
  | {
      area: MemoryDragDropArea.AISuggestion;
      suggestionId: number;
    }
  | {
      area: MemoryDragDropArea.LoggedHour;
      hourId: number;
    }
  | {
      area: MemoryDragDropArea.MemoryInbox;
    }
  | {
      area: MemoryDragDropArea.PendingDraft;
    }
  | {
      area: MemoryDragDropArea.HourDraft;
    };

export interface MemoryDndItem {
  memoryIds: Array<number>;
  source: DropActionAreaSpecifier;
}

export interface MemoryDragDropAction {
  memoryIds: Array<number>;
  source: DropActionAreaSpecifier;
  target: DropActionAreaSpecifier;
}

const MemoryDnD = {
  TYPE: 'memory-entry',
  AREA: MemoryDragDropArea,
} as const;
export default MemoryDnD;
